import type { Image } from '@virginexperiencedays/products';

export const assignContentType = (
  image: Image
): {
  url: string;
  altText: string;
  caption: string;
  type: string;
} | null => {
  if (!image) return null;
  switch (true) {
    case image.url.includes(`youtube`):
      return {
        type: 'yt',
        ...image,
      };
    default:
      return {
        type: 'img',
        ...image,
      };
  }
};
